import * as rudderanalytics from 'rudder-sdk-js';

rudderanalytics.ready(() => {
  console.log('we are all set!!!');
});

rudderanalytics.load(
  process.env.REACT_APP_RUDDER_WRITE_KEY,
  process.env.REACT_APP_RUDDER_DATA_URL,
  {
    context: {
      tenantId: process.env.REACT_APP_TENANT_NAME,
    },
  }
);

export default rudderanalytics;
